import { Observable } from "rxjs";
import { ProductIdentifierDto, TechGroupFeatureListGetQueryResult, TechGroupFeatureRegisterListGetQueryResult, TechGroupGetQueryResult } from "../../INTEGRA_Shop_Client";
import { InjectionToken } from "@angular/core";


export abstract class ITechGroupService {
  abstract techGroupGetAsync(techGroupNumber: string): Promise<TechGroupGetQueryResult>;

  abstract techGroupFeatureListGet(techGroupNumber?: string, productList?: ProductIdentifierDto[], filterNonTrueBoolAttributes?: boolean): Observable<TechGroupFeatureListGetQueryResult>;

  abstract techGroupFeatureRegisterListGet(techGroupNumber?: string, productList?: ProductIdentifierDto[], filterNonTrueBoolAttributes?: boolean): Observable<TechGroupFeatureRegisterListGetQueryResult>
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ITechGroupServiceToken = new InjectionToken<ITechGroupService>('ITechGroupServiceToken');
